/**
 * Trims a search term and collapses internal runs of whitespace.
 *
 * Not for the API's benefit — it tokenizes anyway, and `"  cat  swap  "`
 * returns exactly the same results as `"cat swap"`. This exists for the places
 * where the raw string is used as an identity: recent searches de-duplicate
 * case-insensitively but not whitespace-insensitively, so `"cat "` and `"cat"`
 * would persist as two identical-looking rows, and the in-flight request is
 * keyed on the term, so the same search would be issued twice.
 */
const formatSearchKeyword = (keyword: string): string => keyword.trim().replace(/\s+/g, ' ');

export default formatSearchKeyword;
